import { Component } from '@angular/core';
import { Notification } from '../_types/notification';
import { NotificationsService } from '../_services/notifications.service';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { LocalStorageService } from 'angular-web-storage';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ChatService } from '../../chat/_services/chat.service';
import { UsersService } from '../../users/_services/users.service';
import { User } from '../../users/_types/user';
import { LoginService } from '../../login/login.service';
import { CostsCentersModule } from '../../costs-center/costs-centers.module';
import { CasesServicesService } from '../../cases/_services/cases-services.service';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { WhatsappChatService } from "../../whatsapp/_services/whatsapp-chat.service";

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrls: ['./notifications-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class NotificationsListComponent {

  public notifications: Notification[] = [];
  public notificationTypes: any[] = [];
  public users: User[] = [];
  public user: any = {};
  public selectedState: string = "NotReaded";
  public notificationStates: any[] = [];

  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    content: new Filter(FilterOperation.contains, 'content'),
    source: new Filter(FilterOperation.equals, 'source'),
    userId: new Filter(FilterOperation.equals, 'userId')
  };

  public stateChip: Filter = new Filter(FilterOperation.equals, 'readedAt', '', 'NotReaded');
  public userOptions: { label: string; value: any }[] = [];
  public typeOptions: { label: string; value: any }[] = [];
  public stateOptions: { label: string; value: any }[] = [];
  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.content, type: 'text', label: 'Contenido', base: true },
    { filter: this.filters.userId, type: 'select', label: 'Usuario', options: this.userOptions, filterable: true, base: true },
    { filter: this.filters.source, type: 'select', label: 'Tipo', options: this.typeOptions, base: true },
    { filter: this.stateChip, type: 'select', label: 'Estado', options: this.stateOptions, base: true }
  ];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    public notificationsService: NotificationsService,
    private topbarService: TopbarService,
    private router: Router,
    private storage: LocalStorageService,
    private chatService: ChatService,
    private usersService: UsersService,
    private loginService: LoginService,
    private casesServicesService: CasesServicesService,
    private whatsappChatService: WhatsappChatService
  ) {
    this.loadUserData();
    this.loadUsers();
    this.loadNotificationTypes();
    this.loadNotificationStates();
    this.allowWrite = this.loginService.hasPermission("NOTIFICATIONS.WRITE");
    this.allowDelete = this.loginService.hasPermission("NOTIFICATIONS.DELETE");
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Notificaciones");
    this.filters.userId.value = this.user.id;
    this.loadUserOptions();
  }

  loadUserData() {
    let user = this.storage.get("user");
    if (user) this.user = this.storage.get("user");
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;
    this.selectedState = this.stateChip.value;


    if (this.selectedState == "Readed") {
      this.filters.readedAt = new Filter(FilterOperation.equals, 'readedAt', '', null, false);
    } else if (this.selectedState == "NotReaded") {
      this.filters.readedAt = new Filter(FilterOperation.equals, 'readedAt', '', null, true);
    } else {
      delete this.filters.readedAt;
    }

    let params: IParamsCollection = {
      sort: ['createdAt'],
      include: ['user'],
      filter: FilterBuilder.fromObject(this.filters).build()
    };

    if(typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    let response = await firstValueFrom(this.notificationsService.all(params));
    this.notifications = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  private async loadUserOptions() {
    let response = await firstValueFrom(this.usersService.all({ page: { size: 5000, number: 1 }, sort: ['name'], fields: { users: 'name' } }));
    this.userOptions.length = 0;
    this.userOptions.push(...response.data.map((u: any) => ({ label: u.name, value: u.id })));
  }

  async loadUsers(event?: any) {
       let text = "";
      if (event != null) text = event.filter; 
      let filters = {
        name: new Filter(FilterOperation.contains, 'name', '', text)      
      };
      let params: IParamsCollection = {
        page: { size: 100, number: 1 },
        sort: ['name'],
        filter: FilterBuilder.fromObject(filters).build()
      };

    let response = await firstValueFrom(this.usersService.all(params));
    this.users = response.data;
    if(text == "" && this.users.findIndex(u => u.id == this.user.id) == -1){
      //por si no lo ha encontrado en los 100 primeros resultados, se lo añadimos
      this.users.unshift(this.user);
    }
  }


  loadNotificationTypes() {
    this.notificationTypes = this.notificationsService.notificationTypes();
    this.typeOptions.length = 0;
    this.typeOptions.push(...this.notificationTypes);
  }

  loadNotificationStates() {
    this.notificationStates = this.notificationsService.notificationStates();
    this.stateOptions.length = 0;
    this.stateOptions.push(...this.notificationStates);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  async executeAction(notification: Notification) {
    let parts = notification.link.split(":");
    let actionType = parts[0];
    let action = parts.slice(1).join(":");
    if (actionType == "function") {
      this.run.call(this, "this." + action);
      firstValueFrom(this.notificationsService.markAsReaded(notification));
      this.notificationsService.closeNotifications();
    } else if (actionType == "route") {
      if(action.includes("caseServices")){
        //Buscamos el case asociado al caseservice,y navegamos al case
        let caseServiceId = action.split("/").pop();
        let caseservice = await firstValueFrom(this.casesServicesService.get(caseServiceId!));
        this.router.navigate(["/cases/", caseservice.caseId]);
      }else{
        this.router.navigate([action]);
      }
      firstValueFrom(this.notificationsService.markAsReaded(notification));
      this.notificationsService.closeNotifications();
    }
  }

  private run(pString: string) {
    return eval(pString)
  }

  async markAsReaded(notification: Notification) {
    await firstValueFrom(this.notificationsService.markAsReaded(notification));
  }

  async openChat(code: string) {
    this.chatService.openChatRoom(code);
  }

  //invocado por executeAction desde el Link 'function:openWhatsappChat(...)' de la notificacion
  async openWhatsappChat(phoneNumber: string, caseId?: string) {
    this.whatsappChatService.open(phoneNumber, undefined, caseId ? caseId : undefined);
  }

}
